import { createSelector } from 'reselect';
import WidgetModel from '../model/WidgetModel';
import { activeChatbotEditorPageSelector } from './viewSelectors';
import { StoreState } from '../store-interfaces';

export const selectWidgets = (state: StoreState) => state.widget.entities;

const selectActivePageId = (state: StoreState) => {
  const activeChatbotEditorPage = activeChatbotEditorPageSelector(state);

  return activeChatbotEditorPage ? activeChatbotEditorPage.id : undefined;
};

export const widgetsByDialogueSelector = (
  pageId: number | undefined,
  widgets: WidgetModel[],
  all?: boolean,
): WidgetModel[] => {
  if (all) {
    return widgets;
  }
  if (pageId) {
    return widgets.filter(widget => widget.pageId === pageId);
  }

  return [];
};

export const widgetsByDialogueReselectSelector = createSelector(
  [selectActivePageId, selectWidgets],
  widgetsByDialogueSelector,
);

export const selectWidgetsByDialogueId =
  (id: number | undefined) =>
  (state): WidgetModel[] =>
    createSelector([selectWidgets], widgets =>
      widgetsByDialogueSelector(id, widgets),
    )(state);
